import { cn } from '@/lib';
import type { ButtonHTMLAttributes, ReactNode } from 'react';

export interface PrimaryButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  children: ReactNode;
  isLoading?: boolean;
  fullWidth?: boolean;
  size?: 'sm' | 'md' | 'lg';
}

const sizeClasses = {
  sm: 'py-1 px-3 text-xs',
  md: 'py-1.5 px-3 text-sm',
  lg: 'py-2 px-4 text-base',
};

export function PrimaryButton({
  children,
  isLoading = false,
  fullWidth = false,
  size = 'md',
  className,
  disabled,
  ...props
}: PrimaryButtonProps) {
  return (
    <button
      className={cn(
        'inline-flex justify-center items-center gap-x-2 font-medium rounded-sm border border-transparent bg-primary text-onprimary hover:bg-primary-darker focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none transition-colors',
        sizeClasses[size],
        fullWidth && 'w-full',
        className
      )}
      disabled={disabled || isLoading}
      {...props}
    >
      {isLoading && (
        <span className="animate-spin inline-block size-4 border-2 border-current border-t-transparent rounded-full" />
      )}
      {children}
    </button>
  );
}
